module.exports = __webpack_public_path__ + "static/media/cabs-icon-blue.6e5712b4.PNG";